import { ColumnDef } from '@tanstack/react-table'
import { GetRegisteredPlayerTableData } from '@/modules/manage-player/type'
import { formatDistanceToNowStrict } from 'date-fns'
import { th } from 'date-fns/locale'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { SortingArrows } from '@/common/components/SortingArrows'
import { PhoneCell } from '@/common/components/PhoneCell'
import { UsernameCell } from '@/common/components/UsernameCell'

export const columns: ColumnDef<GetRegisteredPlayerTableData>[] = [
	{
		accessorKey: 'username',
		header: 'ข้อมูลผู้เล่น',
		cell: ({ row }) => (
			<div className="space-y-1">
				<div className="block">
					<UsernameCell username={row.original.username} />
				</div>
				<div className="block">
					<PhoneCell playerId={row.original.id} phone={row.original.phone} />
				</div>
				<p className="text-xs text-muted-foreground">
					ช่องทาง: {row.original.channel?.name || '-'}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'createdAt',
		header: ({ column }) => {
			return (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
					className="px-0 hover:bg-transparent"
				>
					วันที่สร้าง
					<SortingArrows sortOrder={column.getIsSorted()} />
				</Button>
			)
		},
		cell: ({ row }) => {
			const distance = formatDistanceToNowStrict(
				new Date(row.original.createdAt),
				{
					locale: th,
					addSuffix: true,
				},
			)
			return distance.replace('ใน ', '')
		},
	},
	{
		id: 'totalDepositAmount',
		header: ({ column }) => {
			return (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
					className="px-0 hover:bg-transparent"
				>
					ยอดฝากทั้งหมด (บาท)
					<SortingArrows sortOrder={column.getIsSorted()} />
				</Button>
			)
		},
		cell: ({ row }) => {
			const amount = row.original.totalDepositAmount
			return (
				<div className="space-y-1">
					<p className="font-medium">
						{amount !== undefined && amount !== null
							? Number(amount).toFixed(2)
							: '0.00'}
					</p>
					<p className="text-xs text-muted-foreground">
						สมัครเมื่อ:{' '}
						{formatDistanceToNowStrict(new Date(row.original.createdAt), {
							locale: th,
							addSuffix: true,
						}).replace('ใน ', '')}
					</p>
				</div>
			)
		},
	},
	{
		id: 'details',
		header: 'การดำเนินการ',
		cell: ({ row }) => (
			<Button asChild variant="outline">
				<Link to={`/operator/get-player-list/player-detail/${row.original.id}`}>
					ดูรายละเอียด
				</Link>
			</Button>
		),
	},
]
